import { checkUsage } from "../utils/commandUtils";
import { findPath } from "../utils/filesystemUtils";

export const cd = {
    name: "cd",
    description: "Changes current directory",
    usage: "cd DIRECTORY",
    run: (args: string[], context: any) => {
        const usageError = checkUsage(args, 1, cd.usage);
        if (usageError) return usageError;

        const input = args[0];
        if (input === "..") {
            if (!context.currentDir.parent) return "Already at root directory";
            context.setCurrentDir(context.currentDir.parent);
            return "";
        }
        if (input === "~") {
            context.setCurrentDir(context.rootDir);
            return "";
        }

        const path = input.split("/").filter(Boolean);
        const newDir = findPath(context.currentDir, path);

        if (!newDir) return `ERROR: cd - No such directory: ${args[0]}`;
        context.setCurrentDir(newDir);

        return "";
    }
};